export default "__VITE_ASSET__b0f06487__"